<template>
  <div id="time-picker">
    <div class="time-part">
      <input
        class="input hourt-input"
        min="0"
        max="24"
        maxLength="2"
        type="number"
        v-model="times.hour"
      />
      <div style="display: flex; align-items: center">
        <p class="input-divider">:</p>
        <input
          class="input minute-input"
          min="0"
          max="60"
          maxLength="2"
          type="number"
          v-model="times.minute"
        />
      </div>
      <div style="display: flex; align-items: center" v-if="needSec">
        <p class="input-divider">:</p>
        <input
          class="input sec-input"
          min="0"
          max="60"
          maxLength="2"
          type="number"
          v-model="times.sec"
        />
      </div>
    </div>
    <div class="now-button">
      <rounded-button height="30px" width="80px" @click="setNow">
        {{ $t("timepicker.nowButton") }}
      </rounded-button>
    </div>
    <div class="clear-button-wrapper">
      <close-icon class="close-icon" @closeIconClicked="clearTime" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TimePicker",
  props: {
    value: {
      required: false
    },
    needSec: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {},
  data: () => ({
    times: {
      hour: "00",
      minute: "00",
      sec: "00"
    }
  }),
  created() {
    this.initTime();
  },
  computed: {
    getTime() {
      const time = this.$moment()
        .hour(this.times.hour)
        .minute(this.times.minute)
        .second(this.times.sec);
      if (this.needSec) {
        return time.format("HH:mm:ss");
      }
      return time.format("HH:mm");
    }
  },
  methods: {
    clearTime() {
      this.times = {
        hour: "00",
        minute: "00",
        sec: "00"
      };
    },
    setNow() {
      if (this.$moment() < this.$moment().hour(8)) {
        this.times = {
          hour: "08",
          minute: "00",
          sec: "00"
        };
      } else if (
        this.$moment() >
        this.$moment()
          .hour(16)
          .minute(30)
      ) {
        this.times = {
          hour: 16,
          minute: 30,
          sec: 0
        };
      } else {
        this.times = {
          hour: this.$moment().format("HH"),
          minute: this.$moment().format("mm"),
          sec: this.$moment().format("ss")
        };
      }
    },
    initTime() {
      if (this.value) {
        const arr = this.value.split(":");
        this.times.hour = arr[0];
        this.times.minute = arr[1];
        this.times.sec = arr.length > 2 ? arr[2] : "00";
      } else {
        this.clearTime();
      }
    }
  },
  watch: {
    value() {
      this.initTime();
    },
    "times.hour"() {
      if (this.times.hour > 23) {
        this.times.hour = 23;
      }
      if ((this.times.hour + "").length > 2) {
        this.times.hour = this.times.hour.substring(1, 3);
      }
      this.$emit("input", this.getTime);
    },
    "times.minute"() {
      if (this.times.minute > 59) {
        this.times.minute = 59;
      }
      if ((this.times.minute + "").length > 2) {
        this.times.minute = this.times.minute.substring(1, 3);
      }
      this.$emit("input", this.getTime);
    },
    "times.sec"() {
      if (this.times.sec > 59) {
        this.times.sec = 59;
      }
      if ((this.times.sec + "").length > 2) {
        this.times.sec = this.times.sec.substring(1, 3);
      }
      this.$emit("input", this.getTime);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#time-picker {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
  padding: 5px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  .time-part {
    display: flex;
    input {
      height: 40px;
      background: rgba(0, 0, 0, 0.05);
      margin-right: 5px;
      margin-left: 5px;
      width: 60px;
      border-radius: 10px;
      border: none;
      text-align: center;
      font-size: 20px;
      // background: rgba(0, 0, 0, 0.05);
      outline: none;
      &:focus {
        background: $color-primary;
        color: white;
      }
    }
    .input-divider {
      font-size: 20px;
    }
  }
  .now-button {
    margin-right: 25px;
  }
  .clear-button-wrapper {
    position: absolute;
    right: 10px;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
